import PrimaryBays from "./PrimaryBays";
export default PrimaryBays;
